import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
		ak:'17be0ce1f1ddc9cecfadc0b6d6161b63',
		secret:'BUuAAnhhKWRfGJ2yZsc.m.eGB1ji1gVx1Pa26ZOqUNmPfJBvT.m',
    user_token:'',
    ticket:{},
    power:'',
    menuData:[
      {
        label:'统计',
        index:'5',
        children:[
          {
            path:'/orderStatistics',
            name:'orderStatistics',
            label:'工单统计',
            url:'/orderStatistics',
            idnex:'5-1'
          }
        ]
      },
      {
        label:'工单发布',
        index:'1',
        children:[
          {
            path:'/publishMyOrders/publishMyOrders',
            name:'publishMyOrders',
            label:'我的工单',
            url:'/publishMyOrders',
            index:'1-1'
          },
          {
            path:'/publishAllOrders/publishAllOrders',
            name:'publishAllOrders',
            label:'全部工单',
            url:'/publishAllOrders',
            index:'1-2'
          }
        ]
      },
      {
        label:'工单处理',
        index:'2',
        children:[
          {
            path:'/pengdingOrders/pengdingOrders',
            name:'pengdingOrders',
            label:'待受理工单',
            url:'/pengdingOrders',
            index:'2-1'
          },
          {
            path:'/pengdingMyOrders/pengdingMyOrders',
            name:'pengdingMyOrders',
            label:'我的工单',
            url:'/pengdingMyOrders',
            index:'2-2'
          },
          {
            path:'/pengdingAllOrders/pengdingAllOrders',
            name:'pengdingAllOrders',
            label:'全部工单',
            url:'/pengdingAllOrders',
            index:'2-3'
          }
        ]
      },
      {
        label:'系统管理',
        index:'3',
        children:[
          {
            path:'/roleManage/roleManage',
            name:'roleManage',
            label:'角色权限管理',
            url:'/roleManage',
            index:'3-1'
          },
          {
            path:'/workManage/workManage',
            name:'workManage',
            label:'工单分配逻辑管理',
            url:'/workManage',
            index:'3-2'
          },
          {
            path:'/autOrderMana/autOrderMana',
            name:'autOrderMana',
            label:'自动接单管理',
            url:'/autOrderMana',
            index:'3-3'
          }
        ]
      },
      {
        label:'问题库管理',
        index:'4',
        children:[
          {
            path:'/questionPool/questionPool',
            name:'questionPool',
            label:'问题库',
            url:'/questionPool',
            index:'4-1'
          }
        ]
      }
    ],
    menuList:[],
    roleDatatype:[],
    url:'',
  },
  mutations: {
      changeUserToen(state,value){
        state.user_token = value
      },
      changeTicket(state,param){
        state.ticket = param
      },
      setPower(state,param){
        state.power = param.data
        console.log(state.power,'我是vuex中的数据')
      },
      setMenu(state,param){
        state.menuList = param.data
      }
  },
  actions: {
    
  }
})
